import React, { useEffect, useRef, useState } from 'react';
import { Upload, Input, Button, message } from 'antd';
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import Iconfont from '@utils/Iconfont';
import { BATCH_RECORD_TYPE, BATCH_IMAGES_TYPE, IMAGE_TYPE } from '@utils/CONST';
import TableUploadView from '../../TableUploadView';
import styles from '../../../index.module.scss';
import localStyles from './index.module.scss';
import API from '@api/api';
import eventBus from '@utils/eventBus';

const SelectionMask = ({ show }) => {
    if (!show) return null;
    return <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.6)', zIndex: 10, cursor: 'not-allowed' }} onClick={(e) => { e.stopPropagation(); e.preventDefault(); }} />
};

export const Image2VideoStartCell = ({ record, showSelectionColumn, isEdit, dataSource, setDataSource, projectId, listSkuByProject, beforeUpload, handleDrop, loading }) => {
    const hasImage = record?.inputImages?.filter(item => item.mainImage === true)?.length === 1;

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <SelectionMask show={showSelectionColumn} />
            {hasImage ? (
                <TableUploadView
                    isEdit={isEdit}
                    showSelectionColumn={showSelectionColumn}
                    projectType={BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH}
                    dataSource={dataSource}
                    setDataSource={setDataSource}
                    url={record?.inputImages?.filter(item => item.mainImage === true)[0]?.url}
                    item={record}
                    type={BATCH_RECORD_TYPE.MAINIMG}
                    width={128}
                    listSkuByProject={listSkuByProject}
                    projectId={projectId}
                    onReupload={(file, fileList, item, type) => beforeUpload(file, fileList, item, type)}
                />
            ) : (
                <div className={styles.coordinationWrap}>
                    <Upload.Dragger
                        accept='image/jpeg,image/png,image/webp,image/avif'
                        listType="picture-card"
                        showUploadList={false}
                        className={styles.MatchClothesUpload}
                        beforeUpload={(file, fileList) => beforeUpload(file, fileList, record, BATCH_RECORD_TYPE.MAINIMG)}
                        onDrop={(e) => handleDrop(e, BATCH_RECORD_TYPE.MAINIMG)}
                        disabled={loading}
                        multiple={false}
                    >
                        <div className={styles.SelectModelBtnContent}>
                            {loading ? <LoadingOutlined /> : <PlusOutlined />}
                            <p>上传首帧图</p>
                        </div>
                    </Upload.Dragger>
                </div>
            )}
        </div>
    );
};

export const Image2VideoEndCell = ({ record, showSelectionColumn, isEdit, dataSource, setDataSource, projectId, listSkuByProject, beforeUpload, handleDrop, loading, uploading, clearMatchLoading }) => {
    const hasImage = !!record?.imageTail;

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <SelectionMask show={showSelectionColumn} />
            {hasImage ? (
                <TableUploadView
                    isEdit={isEdit}
                    showSelectionColumn={showSelectionColumn}
                    projectType={BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH}
                    dataSource={dataSource}
                    setDataSource={setDataSource}
                    url={record?.imageTail}
                    item={record}
                    type={BATCH_RECORD_TYPE.MATCHIMG}
                    width={128}
                    listSkuByProject={listSkuByProject}
                    projectId={projectId}
                    loading={loading || record?.matchLoading}
                    onDeleteAfter={clearMatchLoading}
                    onReupload={(file, fileList, item, type) => beforeUpload(file, fileList, item, type)}
                />
            ) : (
                <div className={styles.coordinationWrap}>
                    <Upload.Dragger
                        accept='image/jpeg,image/png,image/webp,image/avif'
                        listType="picture-card"
                        showUploadList={false}
                        className={styles.MatchClothesUpload}
                        beforeUpload={(file, fileList) => beforeUpload(file, fileList, record, BATCH_RECORD_TYPE.MATCHIMG)}
                        onDrop={(e) => handleDrop(e, BATCH_RECORD_TYPE.MATCHIMG)}
                        disabled={loading || record?.matchLoading}
                        multiple={false}
                    >
                        <div className={styles.SelectModelBtnContent}>
                            {(loading || record?.matchLoading) ? <LoadingOutlined /> : <PlusOutlined />}
                            <p>上传尾帧图</p>
                        </div>
                    </Upload.Dragger>
                </div>
            )}
        </div>
    );
};

export const Image2VideoPromptCell = ({ record, showSelectionColumn, setDataSource, openReferenceDrawer }) => {
    const [text, setText] = useState(record?.prompt || '');
    const [lastFavorPrompt, setLastFavorPrompt] = useState('')

    useEffect(() => {
        setText(record?.prompt || '')
    }, [record?.prompt])

    const handleTextChange = (e) => {
        setText(e.target.value);
    };

    const handleBlur = () => {
        if (text !== record?.prompt) {
            setDataSource(prev => prev.map(item => {
                if (item.skuId === record.skuId) {
                    return { ...item, prompt: text };
                }
                return item;
            }));
        }
    };

    const handleClear = () => {
        setText('');
        setDataSource(prev => prev.map(item => {
            if (item.skuId === record.skuId) {
                return { ...item, prompt: '' };
            }
            return item;
        }));
    };

    const normalizedPrompt = (text || '').trim()
    const isFavorCurrent = !!normalizedPrompt && normalizedPrompt === lastFavorPrompt

    const handleFavorPrompt = async () => {
        if (!normalizedPrompt || isFavorCurrent) return
        try {
            const res = await API.saveCustomMaterialv2({
                func: IMAGE_TYPE.IMAGE_TO_VIDEO,
                type: 'image2VideoPrompt',
                image: normalizedPrompt,
                attr: { title: '未命名' }
            })
            if (res?.code !== 0) throw new Error(res?.message || '收藏失败')
            setLastFavorPrompt(normalizedPrompt)
            eventBus.emit('updateImgToVideoPrompt')
            message.success('收藏成功')
        } catch (error) {
            message.error(error?.message || '收藏失败')
        }
    };

    return (
        <div className={localStyles.promptCellContainer}>
            <SelectionMask show={showSelectionColumn} />
            <Input.TextArea
                value={text}
                onChange={handleTextChange}
                onBlur={handleBlur}
                maxLength={700}
                className={`${localStyles.textArea} ${record?.error ? localStyles.textAreaError : ''}`}
                placeholder="请描述您想要的画面内容，包括主体运动和背景变化等。例如 “把图中的人物姿势改为一只手自然下垂，另一只手叉腰，半身人像”"
            />
            <div className={localStyles.actionsContainer}>
                <Button type="text" size="small" className={localStyles.actionBtn} onClick={handleFavorPrompt}>
                    <Iconfont type={isFavorCurrent ? "icon-StarFilled" : "icon-StarOutlined"} style={isFavorCurrent ? { color: '#FFBC3F' } : undefined} />
                </Button>
                <Button type="text" size="small" className={localStyles.actionBtn} onClick={handleClear}>
                    <Iconfont type="icon-DeleteOutlined" />
                </Button>
                <Button type="text" size="small" 
                className={`${localStyles.actionBtn} ${localStyles.actionBtn2}`}
                onClick={() => openReferenceDrawer && openReferenceDrawer(text || '', 1, record, BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH)}>
                    <Iconfont type="icon-tutorialOutlined" />
                    <span>描述模板</span>
                </Button>
            </div>
        </div>
    );
};